import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "delBox" }
const _hoisted_2 = { class: "delPrompt" }
const _hoisted_3 = { class: "delBtn" }
const _hoisted_4 = { class: "btnBox" }

import {
    Close,
} from "@element-plus/icons-vue";
import { ref, onMounted } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'reNamePage',
  props: {
    name:String
},
  emits: ['closeThis','recognition'],
  setup(__props, { emit: __emit }) {

const props = __props
const inputname=ref('')
onMounted(()=>{
    if(props.name){
        inputname.value=JSON.parse(JSON.stringify(props.name)) || ''
    }
})
const emit = __emit
// 关闭弹窗
const closeBox=()=>{
    emit('closeThis')
}
const tolanguage = ref('')
const fromlanguage=ref('')
const handleClose = () => {
    emit('recognition',inputname.value)
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "delTitle" }, [
      _createElementVNode("span", null, "重命名")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", null, "文件名", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputname).value = $event)),
        style: {"width":"240px"},
        placeholder: "请输入名称"
      }, null, 512), [
        [_vModelText, inputname.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", {
          class: "btnNo",
          onClick: _withModifiers(closeBox, ["stop"])
        }, "取消"),
        _createElementVNode("span", {
          class: "btnOk",
          onClick: _withModifiers(handleClose, ["stop"])
        }, "确定")
      ])
    ])
  ]))
}
}

})